import React from 'react';
import { ErrorMessage } from 'formik';
import FormSteps from '../FormSteps';
import FormField from '../../../../FormField';
import mascotCountry from '../../../../../assets/svg/onboarding/mascot-country.svg';
import pinIcon from '../../../../../assets/svg/pin.svg';

const LocationStep = ({
  formik,
  goToNextStep,
  countries
}) => {
  const handleNext = () => {
    goToNextStep(['country', 'city']);
  };

  return (
    <FormSteps
      header="Which country and city do you live in?"
      description="This helps us connect you with local creatives."
      nextButton={handleNext}
    >
      {/* Country Field */}
      <div className="field">
        <div className="field-body">
          <div className="field m-b-0">
            <div className="control input-icon-wrapper">
              <img
                src={pinIcon}
                alt="location"
                className="input-icon"
              />
              <div className="select is-fullwidth">
                <select
                  className="has-background-white input-with-icon"
                  name="country"
                  onChange={formik.handleChange}
                  value={formik.values.country}
                  onBlur={formik.handleBlur}
                >
                  {countries.map((country, id) => (
                    <option key={id} value={country.value}>
                      {country.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <ErrorMessage
              name="country"
              component="span"
              className="error field-error has-text-danger"
            />
          </div>
        </div>
      </div>

      {/* City Field */}
      <div className="field">
        <div className="field-body">
          <FormField
            additionalInputClasses="has-background-white"
            name="city"
            placeholder="Enter City"
            onChange={formik.handleChange}
            value={formik.values.city}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>
      <img src={mascotCountry} className="mascot-fixed" alt="mascot" />
    </FormSteps>
  );
};

export default LocationStep;